import React from 'react';

import style from './index.scss';

const HeaderPanel = ({ title, data, footerData }) => {
  // FIN-11964 — expose the full value via a native title tooltip so long
  // Transaction IDs are accessible on hover even if the cell truncates.
  // Only string values carry a title (React nodes like Tags are skipped).
  const renderField = (dataItem, dataItemIndex) => {
    if (dataItem) {
      const valueTitle =
        typeof dataItem.fieldValue === 'string'
          ? dataItem.fieldValue
          : undefined;
      return (
        <div key={dataItemIndex} className={style.panelFieldSet}>
          <div className="row">
            <div className="col-sm-6">
              <span className={style.fieldLabel}>
                {dataItem.fieldLabel || '-'}
              </span>
            </div>
            <div className="col-sm-6">
              <span className={style.fieldValue} title={valueTitle}>
                {dataItem.fieldValue || '-'}
              </span>
            </div>
          </div>
        </div>
      );
    }
    return null;
  };

  const panelBodyFields = data.map(renderField);

  const panelFooterFields = footerData.map(renderField);

  return (
    <div className={style.mainPanelContainer}>
      <div className={style.panelBody}>
        <p className={style.headerTitle}>{title}</p>
        {panelBodyFields}
      </div>
      <div className={style.panelFooter}>{panelFooterFields}</div>
    </div>
  );
};

export default HeaderPanel;
